/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2021-12-10 13:22:27
 * @LastEditTime: 2021-12-10 13:23:40
 * @LastEditors: 赵大壮
 */

class DZModelPage {

    total = 0;//一共多少条
    pageSize = 10;//一页多少条
    pageNum = 1;//当前页

    constructor(pageSize: number) {
        this.pageSize = pageSize;
    }

}
export default DZModelPage;